module.exports = __webpack_public_path__ + "media/luxury-2026/estate-front-drone-430d9aca.jpg";